import {Component, Input, OnInit} from '@angular/core';
import {Paths} from '../../../config/config';

@Component({
  selector: 'app-box-product',
  templateUrl: './box-product.component.html',
  styleUrls: ['./box-product.component.scss']
})
export class BoxProductComponent implements OnInit {

  @Input() serie;
  @Input() name;
  @Input() phiInfo;
  @Input() internalWelding;
  @Input() internalBoring;
  @Input() description;
  @Input() slug;
  @Input() img;

  public readonly Paths = Paths;

  constructor() {
  }

  ngOnInit() {
  }

}
